import { LicenseInfo } from 'shared-types/license-info';

import { getBrowserSpecificInfos } from './browser';

export const generateLicenseInfo = (videoFilename: string, userId: string): LicenseInfo => {
  return {
    ...getBrowserSpecificInfos(),
    userId,
    videoFilename,
  };
};
